import { appLocalStorage } from '../utils/storage';
export const draftIdentityKey = (userId, storyId) => `opinion-draft:${userId}:${storyId}`;
export const newMediaId = () => window.crypto?.randomUUID?.()
  || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;

const sessionIds = new Map();
export function opinionDraftId(userId, storyId) {
  const key = draftIdentityKey(userId, storyId);
  try {
    const saved = appLocalStorage.getItem(key);
    if (saved) return saved;
    const id = sessionIds.get(key) || newMediaId();
    appLocalStorage.setItem(key, id);
    sessionIds.set(key, id);
    return id;
  } catch {
    if (!sessionIds.has(key)) sessionIds.set(key, newMediaId());
    return sessionIds.get(key);
  }
}

export function clearDraftIdentity(userId, storyId) {
  const key = draftIdentityKey(userId, storyId);
  sessionIds.delete(key);
  try { appLocalStorage.removeItem(key); } catch { /* Saving has already succeeded. */ }
}
